'use strict';

/**
 *
 * @name: seriesGroup
 *
 */

import DirectiveTemplate from './nn-seasons-group.directive.html';
import './nn-seasons-group.directive.scss';

function SeasonsGroupDirective(
  $timeout,
  transObject,
  seasonsAnalytics
) {

  'ngInject';

  return {
    replace: true,
    restrict: 'A',
    transclude: true,
    scope: {
      content: '&',
      loaded: '='
    },
    template: DirectiveTemplate,
    link: function(scope, element) {

      scope.item = scope.content();
      scope.item.title = scope.item.title || 'SEASONS';
      scope.analytics = seasonsAnalytics;

      function terminate() {

        scope.$destroy();
        element.find('*').remove();
        element.remove();
      }

      if (!scope.item.jsonData.sources || !scope.item.jsonData.sources.length) {
        return terminate();
      }

      scope.item.jsonData.sources.forEach(function(source) {

        scope.item.seasons.some(function(series) {

          if (series.id === source.seasonId) {
            source = series;
          }
        });
      });

      scope.item.seasons.forEach(function(post) {

        if (scope.item.jsonData.sources.length > 1) {

          scope.item.jsonData.sources.some(function(item, index) {

            if (post.id === item.seasonId) {
              post.index = index;

              return true;
            }

            return false;
          });
        }

        transObject.translate(post);
      });

      scope.additionalSeriesArray = [];
      var i = 0;

      scope.item.jsonData.sources.forEach(function(source) {

        scope.item.seasons.some(function(series) {

          i++;

          if (series.id === source.seasonId) {

            var newSeries = angular.copy(series);
            newSeries.tracker = i;
            scope.additionalSeriesArray.push(newSeries);

            return true;
          }

          return false;
        });
      });

      scope.loaded = true;
    }
  };
}

export default SeasonsGroupDirective;



// WEBPACK FOOTER //
// ./app/components/nn-modules/seasons/nn-seasons-group/nn-seasons-group.directive.js